import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, keyframes } from "@mui/material";

// Rotation Animation for Circles
const rotate = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

// Pulsing Animation for Inner Circle
const pulse = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
`;

// Color Change Animation
const colorCycle = keyframes`
    0% { background-color: #8A2BE2; }  /* Blue Violet */
    12.5% { background-color: #9400D3; } /* Dark Violet */
    25% { background-color: #9932CC; } /* Dark Orchid */
    37.5% { background-color: #32CD32; } /* Lime Green */
    50% { background-color: #00FF7F; } /* Spring Green */
    62.5% { background-color: #9370DB; } /* Medium Purple */
    75% { background-color: #BA55D3; } /* Medium Orchid */
    87.5% { background-color: #C71585; } /* Medium Violet Red */
    100% { background-color: #8A2BE2; } /* Loop back */
`;

// Fade In and Out Animation for Circles
const fade = keyframes`
    0%, 100% { opacity: 0; }
    50% { opacity: 1; }
`;

const LoadingSpinner = ({ size = 30 }) => {
    const theme = useTheme();

    // **Bright Oil-in-Water Inspired Color Palette**
    const colors = [
        "#66CDAA",
        "#D8BFD8", "#C71585", "#800080", "#9370DB"
    ];

    return (
        <Box>
            <Box
                sx={{
                    position: "relative",
                    width: size,
                    height: size,
                    margin: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {[...Array(10)].map((_, index) => {
                    const circleSize = size + index * 2; // Each circle grows by 2px
                    const animationSpeed = 0.25 + index * 0.12; // Outer circles rotate slower
                    return (
                        <Box
                            key={index}
                            sx={{
                                position: "absolute",
                                width: circleSize,
                                height: circleSize,
                                border: "14px solid transparent",
                                borderTopColor: colors[index % colors.length],
                                borderRadius: "50%",
                                animation: `${rotate} ${animationSpeed}s linear infinite, ${fade} 3s ease-in-out infinite`,
                                animationDelay: `-${(23 - index) * 0.2}s`,
                            }}
                        />
                    );
                })}

                {/* Existing White Center Circle */}
                <Box
                    sx={{
                        position: "absolute",
                        width: 20,
                        height: 20,
                        background: "white",
                        borderRadius: "50%",
                    }}
                />

                {/* 🆕 Pulsing Color-Changing Circle */}
                <Box
                    sx={{
                        position: "absolute",
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        animation: `${pulse} 2s ease-in-out infinite, ${colorCycle} 6s linear infinite`,
                    }}
                />
            </Box>
        </Box>
    );
};

export default LoadingSpinner;